module.exports = __webpack_public_path__ + "static/img/RASM450_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RASM450_1.png
// module id = a/xd
// module chunks = 0